import { render, staticRenderFns } from "./BusinessJoinStepProcess.vue?vue&type=template&id=860b4dde&scoped=true&"
import script from "./BusinessJoinStepProcess.vue?vue&type=script&lang=js&"
export * from "./BusinessJoinStepProcess.vue?vue&type=script&lang=js&"
import style0 from "./BusinessJoinStepProcess.vue?vue&type=style&index=0&id=860b4dde&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "860b4dde",
  null
  
)

export default component.exports